import { NgModule } from '@angular/core';
import { ListComponent } from './list.component';
import { BrowserModule } from '@angular/platform-browser';
import { AngularFontAwesomeModule } from 'angular-font-awesome';

@NgModule({
  declarations: [ListComponent],
  imports: [
    BrowserModule,
    AngularFontAwesomeModule
  ],
  exports: [ListComponent]
})
export class ListModule { }
